import ProfileSidebar from "../components/layout/ProfileSidebar";
import Header from "../components/layout/Header";
import LatestGames from "../components/layout/LatestGames";
import PopularGames from "../components/layout/PopularGames";
import VideoElement from "../components/VideoElement";
import { Helmet } from "react-helmet";

export default function Home() {

  return (
    <div className="pageStandard">
      <Helmet>
        <title>hjem | matly</title>
      </Helmet>
      <Header />
      <div className="contentRow">

        <ProfileSidebar />

        <div className="card">

          <LatestGames />

          <PopularGames />

        </div>
      </div>
    </div>
  );
}